import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FEATURED_SERVICES, ZHELTA_SYSTEMS_URL } from '../mock';
import { useI18n } from '../context/I18nContext';
import { useSlide } from '../context/SlideContext';

export default function FeaturedService() {
  const { t } = useI18n();
  const { index } = useSlide();
  const s = FEATURED_SERVICES[index] || FEATURED_SERVICES[0];
  // Featured services list wraps at 6; map index accordingly
  const tr = t?.home?.cards?.featured_services?.[index % 6] || {};
  const title = tr.title || s.title;
  const description = tr.description || s.description;
  // All 12 featured services live under ZHELTA Systems today, so the
  // "Learn More" CTA routes there. If a service ever ships its own dedicated
  // page, set `href` on the matching `FEATURED_SERVICES` row in mock.js.
  const href = s.href || ZHELTA_SYSTEMS_URL;
  const isExternal = href.startsWith('http');

  const Cta = isExternal
    ? (props) => <a {...props} href={href} target="_blank" rel="noopener noreferrer" />
    : (props) => <Link {...props} to={href} />;

  return (
    <section className="relative -mt-16 sm:-mt-20 md:-mt-28 z-20">
      <div className="zh-container">
        <div className="bg-white rounded-2xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.25)] px-5 sm:px-7 md:px-12 py-6 sm:py-8 md:py-10">
          <div
            key={index}
            className="zh-fade-in"
          >
            <h2 className="text-xl sm:text-2xl md:text-[28px] font-bold text-gray-900 mb-2 sm:mb-3 leading-tight">
              {title}
            </h2>
            <p className="text-gray-600 text-[14px] sm:text-[15px] leading-relaxed mb-5 sm:mb-6 max-w-4xl">
              {description}
            </p>
            <Cta
              data-testid="featured-service-cta"
              aria-label={`${t.featured.cta} — ${title}`}
              className="zh-btn-gold"
            >
              {t.featured.cta}
              <ChevronRight className="w-4 h-4" />
            </Cta>
          </div>
        </div>
      </div>
    </section>
  );
}
